import { fetch_data_Request, fetch_data_Failure, fetch_data_Success } from "../../actions/actionConstants";

// ДЛЯ ИНДИКАЦИИ ЗАГРУЗКИ ВСЕХ ДАННЫХ

const updateLoadState = (state, action) => {
    if (state === undefined) {
        return {
            loading: true,
            error: false
        };
    }

    switch (action.type) {
        case fetch_data_Request:
            return {
                loading: true,
                error: false
            };
        case fetch_data_Success:
            return {
                loading: false,
                error: false
            };
        case fetch_data_Failure:
            return {
                loading: false,
                error: action.payload
            };

        default:
            return state.app.loadState;
    }
};
export default updateLoadState;
